<template>
  <div
    :class="$style.container"
    data-test-id="CommandTemplateDetailsLayout__container"
  >
    <div
      :class="$style.detailsContent"
      data-test-id="CommandTemplateDetailsLayout__content"
    >
      <slot name="detailsContent" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommandTemplateDetailsLayout',
  inject: ['$validator'],
};
</script>

  <style module>
  @value (max-width-medium) from '~css/breakpoints.css';

  .container {
    display: flex;
    height: 100%;
    position: var(--containerPosition, static); /* Variable declared in parent component */
  }

  .detailsContent {
    box-sizing: border-box;
    height: 100%;
    overflow: auto;
    padding: 10px 20px 10px;
    width: 100%;
  }

  </style>
